import React from 'react';
import studentStyles from '../styles.module.css';

function StudentHomework() {
    return (
        <div className={studentStyles.mainSection}>
            Under Development
        </div>
    )
}

export default StudentHomework;
